import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Web Speech API pronunciation helper (fi-FI)
export function speak(text) {
  if (typeof window === "undefined" || !window.speechSynthesis) return;
  try {
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = "fi-FI";
    u.rate = 0.9;
    const voices = window.speechSynthesis.getVoices();
    const fi = voices.find((v) => v.lang && v.lang.toLowerCase().startsWith("fi"));
    if (fi) u.voice = fi;
    window.speechSynthesis.speak(u);
  } catch (e) {
    /* no-op */
  }
}
